import React from 'react';
import { IconProps } from '../../icons/types';

const AllocationNavbarIcon: React.FC<IconProps> = props => {
  const { height = 24, width = 24, fillColor = 'white' } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3846_49405)">
        <circle cx="16.125" cy="17.625" r="4.375" stroke={fillColor} />
        <path
          d="M14.7185 18.0344L15.6435 17.1094L15.6435 19.6719C15.6435 19.8135 15.6914 19.9323 15.7873 20.0281C15.8831 20.124 16.0018 20.1719 16.1435 20.1719C16.2852 20.1719 16.4039 20.124 16.4998 20.0281C16.5956 19.9323 16.6435 19.8135 16.6435 19.6719L16.6435 17.1094L17.581 18.0594C17.681 18.1594 17.7998 18.2094 17.9373 18.2094C18.0748 18.2094 18.1935 18.1594 18.2935 18.0594C18.3935 17.9594 18.4456 17.8406 18.4498 17.7031C18.4539 17.5656 18.406 17.4469 18.306 17.3469L16.4935 15.5219C16.4018 15.4302 16.2852 15.3844 16.1435 15.3844C16.0018 15.3844 15.8852 15.4302 15.7935 15.5219L14.006 17.3094C13.906 17.4094 13.8539 17.5302 13.8498 17.6719C13.8456 17.8135 13.8935 17.9344 13.9935 18.0344C14.0935 18.1344 14.2143 18.1844 14.356 18.1844C14.4977 18.1844 14.6185 18.1344 14.7185 18.0344Z"
          fill={fillColor}
        />
      </g>
      <path
        d="M15.2465 3H3.18966C3.08296 3 2.99997 3.08299 2.99997 3.18968V17.6057"
        stroke={fillColor}
        strokeWidth="1.2"
        strokeMiterlimit="10"
      />
      <path
        d="M9.93515 20.4155H5.88065C5.77396 20.4155 5.69097 20.3325 5.69097 20.2258V5.89281C5.69097 5.78611 5.77396 5.70312 5.88065 5.70312H17.3328C17.4395 5.70312 17.5225 5.78611 17.5225 5.89281V11.0101"
        stroke={fillColor}
        strokeWidth="1.2"
        strokeMiterlimit="10"
      />
      <defs>
        <clipPath id="clip0_3846_49405">
          <rect width="9.75" height="9.75" fill={fillColor} transform="translate(11.25 12.75)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default AllocationNavbarIcon;
